import { render, staticRenderFns } from "./AdminSettingWorkflowComments.vue?vue&type=template&id=1aa1b456&scoped=true&"
import script from "./AdminSettingWorkflowComments.vue?vue&type=script&lang=js&"
export * from "./AdminSettingWorkflowComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1b456",
  null
  
)

export default component.exports